export default __webpack_public_path__ + "static/media/banner.65189da6.svg";